module.exports = __webpack_public_path__ + "static/media/vignobles1.2b78e5ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/vignobles1.jpg
// module id = 103
// module chunks = 0